import React from 'react';
import { APP_NAME } from '../../config/appConstants';
import PublicInfoLayout from '../../shared/components/layouts/PublicInfoLayout';
import './LegalPages.css';

export default function PrivacyPolicyPage() {
  const updatedAt = 'May 27, 2026';

  return (
    <PublicInfoLayout>
      <h1>Privacy Policy</h1>
      <p className="legal-subtitle">
        {APP_NAME} • Last updated: {updatedAt}
      </p>

      <h2>Overview</h2>
      <p>
        This Privacy Policy explains how {APP_NAME} collects, uses, and protects information when you use the
        application.
      </p>

      <h2>Information we process</h2>
      <ul>
        <li><strong>Account information</strong>: such as your name, email, role, and organization context.</li>
        <li><strong>Operational data</strong>: device, complaint, maintenance, and workflow information you enter or view.</li>
        <li><strong>Usage/security data</strong>: authentication/session identifiers and basic technical metadata needed to operate securely.</li>
      </ul>

      <h2>How we use information</h2>
      <ul>
        <li>To provide core product functionality and maintain data integrity.</li>
        <li>To authenticate users, manage sessions, and prevent unauthorized access.</li>
        <li>To support auditing, troubleshooting, and operational reporting.</li>
      </ul>

      <h2>Contact</h2>
      <p>
        For privacy questions, please contact your system administrator or the organization that provided your access
        to {APP_NAME}.
      </p>
    </PublicInfoLayout>
  );
}

